import { Component, Input, OnInit } from '@angular/core';
import { GeneralService } from 'src/app/shared/services/general.service';
import { AdDefaults } from '../ad-default';


@Component({
    selector: 'plants',
    templateUrl: './plants.component.html',
    styleUrls: ['./plants.component.scss']
})
export class PlantsComponent extends AdDefaults implements OnInit {

    @Input() info : any;
    @Input() plain : any = false;
    @Input() swiperConfig : any;

    init = false;

    constructor( 
        protected gs : GeneralService
    ){
        super(gs);
    }

    ngOnInit(){
        super.ngOnInit();
        if(this.info?.imagesPlants?.length==1)
            this.swiperConfig.slidesPerView = 1; 

        this.init = true;
    }

}